import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);

const opts = {
	theme: {
		themes: {
			light: {
				primary: "#5900B3",
				secondary: "#CE93D8",
				accent: "#E040FB",
				error: "#FF1744",
				warning: "#AB000E",
				info: "#C0CA33",
				success: "#009600"
			}
		}
	}
};

export default new Vuetify(opts);



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js